/** @file Unit direction of an image or screen angle (y down): 0 down, 90 right. */
import { degToRad } from '@zilo/pose3d-math/angle/degToRad';

/** `v`, with the float residue of a cardinal angle (`sin 180` = 1.2e-16) made exactly 0. */
const exact = (v: number): number => (Math.abs(v) < 1e-12 ? 0 : v);

/** `[sin a, cos a]`; cardinal angles give exact axis directions, so half-pixel pivots slide exactly. */
export function imageDirOf(angleDeg: number): [number, number] {
  const a = degToRad(angleDeg);
  return [exact(Math.sin(a)), exact(Math.cos(a))];
}
